Monitoring.Models.SocialContents ||= {}
# Warning: Duplicated code with Keepcon's social_content_factory.rb.
class Monitoring.Models.SocialContents.SocialContentFactory

  constructor: ->
    @factories = [
      new Monitoring.Models.SocialContents.TwitterContentFactory,
      new Monitoring.Models.SocialContents.FacebookContentFactory,
      new Monitoring.Models.SocialContents.InstagramStoryContentFactory,
      new Monitoring.Models.SocialContents.InstagramMediaContentFactory,
      new Monitoring.Models.SocialContents.InstagramCommentContentFactory,
      new Monitoring.Models.SocialContents.InstagramBusinessDiscoveryListeningContentFactory
      new Monitoring.Models.SocialContents.TwitterApiContentFactory,
      new Monitoring.Models.SocialContents.GnipTwitterContentFactory,
      new Monitoring.Models.SocialContents.YoutubeContentFactory,
      new Monitoring.Models.SocialContents.ImageContentFactory,
      new Monitoring.Models.SocialContents.ClippingContentFactory,
      new Monitoring.Models.SocialContents.GoogleSearchContentFactory,
      new Monitoring.Models.SocialContents.ApplestoreContentFactory,
      new Monitoring.Models.SocialContents.ReviewCommentFactory,
      new Monitoring.Models.SocialContents.WebchatContentFactory,
      new Monitoring.Models.SocialContents.LinkedInContentFactory,
      new Monitoring.Models.SocialContents.GoogleMyBusinessContentFactory,
      new Monitoring.Models.SocialContents.TikTokAdContentFactory,
      new Monitoring.Models.SocialContents.TikTokCommentContentFactory,
      new Monitoring.Models.SocialContents.TikTokPostContentFactory,
      new Monitoring.Models.SocialContents.TikTokMessageContentFactory,
      new Monitoring.Models.SocialContents.EmailContentFactory,
      new Monitoring.Models.SocialContents.InboxContentFactory # Always at the end of the list!
    ]

  create: (object, allTags) ->
    socialContent = undefined
    factory = _.find @factories, (factory) => factory.canHandle(object)
    if factory
      socialContent = factory.create(object, allTags)
    else if object.data?.text == Monitoring.Models.SocialContents.SocialContent.NOT_FOUND_TEXT
      socialContent = new Monitoring.Models.SocialContents.InboxContentFactory().create(object, allTags)
    else
      console.log('SocialContentFactory not found for object', object)
      throw('SocialContentFactory: Factory not found for object: ' + JSON.stringify(object))
    socialContent
